import React from 'react';
import './Search.css';
import { RootStoreContext } from '../../../../../context';

class Search extends React.Component {

  static contextType = RootStoreContext;

  render () {
    return (
      <input
        id="private-chat-sidebar-search"
        className="search-field"
        type="text"
        placeholder="Search by nickname or username"
        onChange={event => this.context.privateMessagingStore.search(event.target.value)}
      />
    );
  }
}

export default Search;